export const LOAD_STATE = 'LOAD_STATE';
export const LOAD_DIALOG_STATE = 'LOAD_DIALOG_STATE';
export const RESET_BUDGET = 'RESET_BUDGET';
export const RESET_FIELDS = 'RESET_FIELDS';
export const SET_DIALOG_LOADING = 'SET_DIALOG_LOADING';
export const SET_TABLE_LOADING = 'SET_TABLE_LOADING';
export const SET_ERRORS = 'SET_ERRORS';
export const SET_FORM_TYPE = 'SET_FORM_TYPE';
export const SET_SELECTED_PROJECTS = 'SET_SELECTED_PROJECTS';
export const SET_SUBMITTING = 'SET_SUBMITTING';
export const TRANSFORM_INITIAL_STATE = 'TRANSFORM_INITIAL_STATE';
export const UPDATE_AUTO_INVOICING = 'UPDATE_AUTO_INVOICING';
export const UPDATE_FIELD = 'UPDATE_FIELD';
export const UPDATE_PROJECTS = 'UPDATE_PROJECTS';
export const SET_UPLOAD_LOADING = 'SET_UPLOAD_LOADING';
export const REMOVE_FILE = 'REMOVE_FILE';
export const SET_FILE_PARAMS = 'SET_FILE_PARAMS';
export const SET_IMPORT_STATE = 'SET_IMPORT_STATE';
export const TOGGLE_IMPORT_DIALOG = 'TOGGLE_IMPORT_DIALOG';
export const SET_STATUS = 'SET_STATUS';
export const SET_BATCH_ACTION_IDS = 'SET_BATCH_ACTION_IDS';
export const SET_FILTER = 'SET_FILTER';
